module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-amap', {
    attrs: {
      "vid": "amapDemo",
      "zoom": _vm.zoom,
      "center": _vm.center,
      "scrollWheel": _vm.scrollWheel
    }
  }, [_vm._l((_vm.markers), function(marker, index) {
    return _c('el-amap-marker', {
      key: index,
      attrs: {
        "position": marker.position
      }
    })
  }), _vm._v(" "), _vm._l((_vm.windows), function(window, index) {
    return _c('el-amap-info-window', {
      key: index,
      attrs: {
        "title": window.title,
        "position": window.position,
        "content": window.content,
        "open": window.open
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37931737","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUs/map/zero.vue
// module id = 802
// module chunks = 0